import React, { useState, useEffect } from 'react';
import { Container, TabPane, TabContent } from 'reactstrap';

import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import NavTab from '../../shared/components/custom/NavTab';
import { partial } from '../../util/translation/translation';
import AppSponsor from './components/AppSponsor';
import GoalServiceSponsor from './components/GoalServiceSponsor';
import config from '../../config';
import WebsiteSponsor from './components/WebsiteSponsor';
import useConfig from '../../util/useConfig';

const s = partial('shared');
const p = partial('CompanyListPage');
const ct = partial('Category');

const SponsorsListPage = () => {
  const [clubProfile, setclubProfile] = useState();
  const [loadingSponsor, setLoadingSponsor] = useState(false);
  const [tab, setTab] = useState(false);
  const { id: clubId, featureFlags } = useConfig();

  const getAppSponsor = async () => {
    setLoadingSponsor(true);
    try {
      const { data: clubData } =
        await Api.clubadmin.profile.fetchProfile(clubId);
      setLoadingSponsor(false);
      setclubProfile(clubData);
    } catch (err) {
      setLoadingSponsor(false);
      toast.error(err || `${s('somethingWentWrong')}`);
    }
  };

  useEffect(() => {
    if (!clubProfile) {
      getAppSponsor();
    }
  }, [clubProfile]);

  const handleSubmitAppSponsor = async ({ selectedCompany }) => {
    setLoadingSponsor(true);
    try {
      const payload = {
        clubProfile,
        appSponsorId: selectedCompany.value.id,
        clubId,
      };
      await Api.clubadmin.profile.post(payload);
      toast.success(`${p('categoryCreated')}`);
      getAppSponsor();
    } catch {
      setLoadingSponsor(false);
    }
  };

  const isLoading = loadingSponsor;
  const availableTabs = [
    'App sponsor',
    `${ct('goalService')}`,
    config.clubWebsiteEnabled || featureFlags?.includes('website')
      ? `${ct('websiteSponsor')}`
      : null,
  ].filter(Boolean);

  return (
    <Container>
      <Loading loading={isLoading} />
      <div
        style={{
          marginBottom: 10,
          background: '#fff',
          borderRadius: 6,
          boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
        }}
      >
        <NavTab
          activeTab={tab}
          tabs={availableTabs}
          setTab={setTab}
          size="sm"
        />
        <TabContent activeTab={tab} style={{ padding: 15 }}>
          <TabPane tabId="1">
            <AppSponsor
              onSubmit={handleSubmitAppSponsor}
              isLoading={loadingSponsor}
              appSponsorId={clubProfile?.appSponsorId}
            />
          </TabPane>
          <TabPane tabId="2">
            <GoalServiceSponsor />
          </TabPane>
          {(config.clubWebsiteEnabled || featureFlags?.includes('website')) && (
            <TabPane tabId="3">
              <WebsiteSponsor />
            </TabPane>
          )}
        </TabContent>
      </div>
    </Container>
  );
};

export default SponsorsListPage;
